import { Modal } from '@trackman/web-shared-components';
import './SubscriptionPromptDialog.scss';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Crown } from 'images/icons/Crown.svg';
import { ReactComponent as Checkmark } from 'images/icons/Checkmark.svg';
import { ReactComponent as Close } from 'images/icons/Close.svg';
import Subtitle from 'components/TextComps/Subtitle';

type Props = {
  open: boolean;
  onClose: () => void;
  handleAddToCart: () => void;
};

export const SubscriptionPromptDialog = ({ open, onClose, handleAddToCart }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      className='subscription-prompt-modal'
      cancelBtn={{
        label: t('NoThankYou', { ns: 'subscriptionsAndPricing' }),
        onClick: onClose,
      }}
      confirmBtn={{
        label: t('SubscribeAndSave', { ns: 'subscriptionsAndPricing' }),
        onClick: () => handleAddToCart(),
        intent: 'secondary',
      }}
      onClose={onClose}
      title={t('UpgradeToPremiumAndGet50%Off', { ns: 'subscriptionsAndPricing' })}
      open={open}
    >
      <p>{t('Pay$175Annually', { ns: 'subscriptionsAndPricing' })}</p>
      <div className='subscription-prompt-offers-comparison'>
        <div className='subscription-prompt-card subscription-prompt-card__premium'>
          <div className='subscription-prompt-premium-header'>
            <Crown className='subscription-prompt-premium-header-icon' />
            <Subtitle>{t('WithPremium', { ns: 'subscriptionsAndPricing' })}</Subtitle>
          </div>
          <div className='subscription-prompt-price'>
            <h2>{t('$375', { ns: 'subscriptionsAndPricing' })}</h2>
            <span className='subscription-prompt-price-description'>
              <>{t('$175ForPremium', { ns: 'subscriptionsAndPricing' })}</>
            </span>
          </div>
          <SubscriptionBenefits isPremiumPlan={true} />
        </div>
        <div className='subscription-prompt-card subscription-prompt-card__free'>
          <Subtitle>{t('WithoutPremium', { ns: 'subscriptionsAndPricing' })}</Subtitle>
          <div className='subscription-prompt-price'>
            <h2>{t('$400', { ns: 'subscriptionsAndPricing' })}</h2>
            <span className='subscription-prompt-price-description'>
              <>{t('CertificateOnly', { ns: 'subscriptionsAndPricing' })}</>
            </span>
          </div>
          <SubscriptionBenefits isPremiumPlan={false} />
        </div>
      </div>
    </Modal>
  );
};

const SubscriptionBenefits = ({ isPremiumPlan }: { isPremiumPlan: boolean }) => {
  const { t } = useTranslation();
  return (
    <div className='subscription-benefits-list'>
      <div className={isPremiumPlan ? 'subscription-benefit-item' : 'subscription-benefit-item subscription-benefit-item__free'}>
        {isPremiumPlan ? <Checkmark /> : <Close />}
        {t('50%OffAllCertificates', { ns: 'subscriptionsAndPricing' })}
      </div>
      <div className={isPremiumPlan ? 'subscription-benefit-item' : 'subscription-benefit-item subscription-benefit-item__free'}>
        {isPremiumPlan ? <Checkmark /> : <Close />}
        {t('AccessToAllChapterTests', { ns: 'subscriptionsAndPricing' })}
      </div>
      <div className={isPremiumPlan ? 'subscription-benefit-item' : 'subscription-benefit-item subscription-benefit-item__free'}>
        {isPremiumPlan ? <Checkmark /> : <Close />}
        {t('OnDemandWebinars', { ns: 'subscriptionsAndPricing' })}
      </div>
    </div>
  );
};
